// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__os6By","footerInner":"style_footerInner__pA7-t","logo":"style_logo__ahmnK"};